import RemaxLogo from './logos/remax.svg';
import DouglasLogo from './logos/douglas-elliman.svg';
import SothebyLogo from './logos/sothebys.svg';
import CompassLogo from './logos/compass.svg';
import Goldwell from './logos/goldwell.svg';

export const LOGOS = {
  RemaxLogo, DouglasLogo, SothebyLogo, CompassLogo, Goldwell
}